import { Box, Divider, Typography } from "@material-ui/core";
import React from "react";
import { Survey } from "survey-react-ui";
import Button from "components/CustomButtons/Button.js";
import "../qu-brand.css";
import { StylesManager } from "survey-core";


const PreviewForm = ({ json, onClickNext, version }) => {
    const headerTitle = "Preview Form";
    const headerDesc = "Preview the form and publish it if you are satisfied.";
    return (
        <div>
            <Box display="flex" alignItems="center">
                <Box>
                    <Typography variant="h5">{headerTitle}</Typography>
                    <Typography variant="body1">{headerDesc}</Typography>
                </Box>
                <Box ml={2} style={{ marginLeft: "auto" }}>
                    <Box display="flex" alignItems="center">
                        <Typography variant="body1">Current Preview <br /><small style={{ float: "right" }}>Version {version}</small></Typography>
                        <Button
                            color="success"
                            variant="contained"
                            onClick={onClickNext}
                            style={{ marginLeft: "32px" }}
                        >
                            Publish Form
                        </Button>
                    </Box>
                </Box>
            </Box>
            <Divider style={{ marginTop: "16px", marginBottom: "16px" }} />
            <div className="qu-theme">
                <Survey json={json} />
            </div>
        </div>
    );
};



export default PreviewForm;
